var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"main-wrapper"},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{staticClass:"m-no-padding",attrs:{"xs":24,"sm":18,"md":18}},[_c('hot-list-view')],1),_c('el-col',{attrs:{"xs":24,"sm":6,"md":6}},[_c('right-sider-bar')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }